<div class="d-md-flex align-items-center bg-white p-4 ng-star-inserted">
    <div>
        <label>Seriale</label>
        <input class="form-control" (ngModelChange)="onInput($event)" type="text" [(ngModel)]="filtro.nome"
            placeholder="Scrivi un Seriale">
    </div>
    <button class="btn btn-cyan p-2 text-white ml-auto" (click)="addSeriale()"><i
            class="fa fa-plus pr-2"></i>Aggiungi</button>
</div>

<div *ngIf="serialiList?.length > 0">
    <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
            <tr>
                <th>Nome</th>
                <th>Seriale</th>
                <th>Quantità</th>
                <th>Data di Acquisto</th>
                <th>Azioni</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let seriale of serialiList">
                <td>{{seriale.prodotto}}</td>
                <td>{{seriale.seriale}}</td>
                <td>{{seriale.quantita}}</td>
                <td>{{seriale.dataAcquisto | date:"dd/MM/yyyy"}}</td>
                <td><i class="fas fa-pencil-alt text-info" (click)="openEdit(seriale)"></i> <i
                        class="fas fa-trash text-danger pl-2" (click)="deleteSeriale(seriale)"></i></td>
            </tr>

        </tbody>
    </table>
</div>